import React from 'react'
import { Typography, Paper } from '@mui/material'
import { headlineStyle, titleCountStyle, titleStyle } from './AnalyticsCard.styles'
import { formatNumber } from '~/src/libs'

interface AnalyticsStockCardProps {
  label: string
  count: string
  units: string
}

export const AnalyticsCard: React.FC<AnalyticsStockCardProps> = ({
  label = '',
  count = '0',
  units = '台',
}) => {
  return (
    <Paper sx={{ p: '20px' }}>
      <Typography component="h2" sx={headlineStyle}>
        {label}
      </Typography>
      <Typography component="p" sx={titleStyle}>
        <Typography component="span" variant="h3" sx={titleCountStyle}>
          {formatNumber(Number(count))}&nbsp;
        </Typography>
        {units}
      </Typography>
    </Paper>
  )
}
